import * as styles from "./CruiseEventTags.module.scss";
import { Trans } from "@lingui/react/macro";
import CardTags from "components/CardTags/CardTags";
import CardTag from "components/CardTags/CardTag";
import React from "react";

type CruiseEventTagsProps = {
  cruiseTags: string[];
};

export const CruiseEventTagsTitle: React.FC = () => {
  return (
    <div className={styles.cruiseTagsRecapTitle}>
      <Trans>This cruise features</Trans>
    </div>
  );
};

export const CruiseEventTagsContent: React.FC<CruiseEventTagsProps> = ({
  cruiseTags
}) => {
  return (
    <CardTags>
      {cruiseTags.map((cruiseTag) => (
        <CardTag
          key={cruiseTag}
          backgroundColor="productType"
          uppercase={false}
          variant="small"
        >
          {cruiseTag}
        </CardTag>
      ))}
    </CardTags>
  );
};
